/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: CustomerAuthDataMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ClientAuthDataMessageHandler = function() {
    com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CLIENT_AUTH_DATA);
};
$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,
    com.inq.flash.client.control.messagehandlers.ClientAuthDataMessageHandler,
    "com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler");
/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ClientAuthDataMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ClientAuthDataMessageHandler.prototype.processMessage = function(message) {
    var clientName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_USERNAME);
    if (clientName != null) {
        com.inq.flash.client.control.FlashVars.setCustomerName(clientName, true);
    }
};

/** @type {com.inq.flash.client.control.messagehandlers.ClientAuthDataMessageHandler} */
com.inq.flash.client.control.messagehandlers.ClientAuthDataMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ClientAuthDataMessageHandler;
